module.exports = __webpack_public_path__ + "img/8.591becb1.png";